import { PlaceType } from 'src/types';

export const supportedPlaceTypes = new Set([PlaceType.Desk, PlaceType.Parking]);
